const isInTheDay = (timestamp, date) => {
    let dateFromTimestamp = new Date(timestamp*1000);
    let inputDate = new Date(date);
    
    return dateFromTimestamp.setHours(0, 0, 0, 0) == inputDate.setHours(0, 0, 0, 0) ? true : false;
}

export default isInTheDay;